/**
 * Pila delle schede del drawer globale, salvata nell'URL come elenco separato da
 * virgole (es. "clients:A,clients:B"). Funzioni pure, usate da useRouteDrawer.
 */
const MAX_DEPTH = 10;

/** Pila dopo aver aperto `next` con `current` gia' aperto. Riaprire la scheda corrente non la duplica. */
export function pushDrawerStack(back: string | null, current: string | null, next: string): string | null {
  const items = back ? back.split(',').filter(Boolean) : [];
  if (current && current !== next) items.push(current);
  return items.length ? items.slice(-MAX_DEPTH).join(',') : null;
}

/** Scheda a cui tornare chiudendo, e la pila che resta. null = pila vuota, si chiude tutto. */
export function popDrawerStack(back: string | null): { current: string; back: string | null } | null {
  const items = back ? back.split(',').filter(Boolean) : [];
  const current = items.pop();
  if (!current) return null;
  return { current, back: items.length ? items.join(',') : null };
}
